import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddonProduct from '../Components/AddonProduct';
import { load, variantClick } from '../Actions/AddonProduct.action';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import withReactiveStyleBuyButtonInverted from './withReactiveStyleBuyButtonInverted';
import { addMultiple as addToCartService } from '../Services/Cart.service';


class AddonProductContainer extends Component {
    constructor(props){
        super(props);
    }

    componentDidMount() {
        this.props.load(this.props.baseProduct);
    }

    render() {
        return <AddonProduct {...this.props}
        onClick={(addons, baseProduct) => this.props.onClick({ addons, baseProduct })}/>
    };
}

const mapStateToProps = state => {
    const { addons } = state;
    return { 
        ...addons,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        load: (baseProduct) => dispatch(load(baseProduct)),
        variantClick: (addon, variant) => dispatch(variantClick(addon, variant)),
        onSuccess: (cart) => dispatch(receive(cart)),
        onError: (ex) => dispatch(catchError(ex, error => loadError(error)))
    }
}

export const onClick = ({addons, baseProduct, canBuy, product}) => {
    
    var quantity = document.getElementById(baseProduct).value;

    if(quantity < 1){
        return undefined;
    }

    var soldOut = false;

    addons.filter(x => x.configVariants.some(y => y.selected == true)).forEach(addon => {
        var selected = addon.configVariants.filter(x => x.selected == true);
        
        if(selected.some(x => x.soldOut)){
            soldOut = true;
        }
    });

    if(soldOut || canBuy == 'false'){
        return undefined;
    }

    var ret = [];

    addons.filter(x => x.configVariants.some(y => y.selected == true)).forEach(addon => {
        addon.configVariants.filter(x => x.selected == true).forEach(variant => {
            ret.push({articleNumber: variant.sku, quantity: quantity});
        });
    });
    ret.push({articleNumber: product, quantity: quantity});

    return addToCartService({ articles: ret });
}

export default connect(mapStateToProps, mapDispatchToProps)(withReactiveStyleBuyButtonInverted(AddonProductContainer, onClick, 'buy-button-container'))